import { RoleService } from "@/api/service-proxies";
export const roleService = new RoleService();
